import React from "react";

interface ItemsAddedModalProps {
  onClose: () => void;
  onViewCart: () => void;
  onContinueShopping: () => void;
}

/** Dark "Items Added" popup — matches mobile reorder confirmation */
const ItemsAddedModal = ({
  onClose,
  onViewCart,
  onContinueShopping,
}: ItemsAddedModalProps) => {
  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center px-6">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="relative w-full max-w-[340px] rounded-2xl bg-[#2C2C2C] px-5 pt-6 pb-4 shadow-xl"
        role="dialog"
        aria-labelledby="items-added-title"
      >
        <h3
          id="items-added-title"
          className="text-white font-urbanist text-lg font-semibold leading-tight"
        >
          Items Added
        </h3>
        <p className="mt-2 text-[#B0B0B0] font-urbanist text-sm leading-relaxed">
          Order items have been added to your cart
        </p>
        <div className="mt-6 flex items-center justify-end gap-5">
          <button
            type="button"
            onClick={onViewCart}
            className="text-[#4ADE80] font-urbanist text-sm font-semibold uppercase tracking-wide"
          >
            View Cart
          </button>
          <button
            type="button"
            onClick={onContinueShopping}
            className="text-[#4ADE80] font-urbanist text-sm font-semibold uppercase tracking-wide"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemsAddedModal;
